import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';

export interface Notification {
  id: string;
  userId: string;
  type: 'like' | 'comment' | 'co_comment' | 'comment_like' | 'event_comment' | 'event_attendee_comment' | 'event_reminder' | 'event_invite' | 'message' | 'new_post';
  title: string;
  message: string;
  relatedEntityId: string | null;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationListResponse {
  notifications: Notification[];
  total: number;
}

export interface UnreadCountResponse {
  count: number;
}

/**
 * Get user's notifications
 */
export const getNotifications = async (
  page: number = 1,
  limit: number = 20
): Promise<NotificationListResponse> => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/notifications`, {
    params: { page, limit },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const responseData = response.data;

  if (Array.isArray(responseData)) {
    return {
      notifications: responseData,
      total: responseData.length,
    };
  }

  return {
    notifications: responseData?.notifications ?? [],
    total: responseData?.total ?? responseData?.notifications?.length ?? 0,
  };
};

/**
 * Get count of unread notifications
 */
export const getUnreadCount = async (): Promise<number> => {
  const token = localStorage.getItem('token');
  const response = await axios.get<UnreadCountResponse>(
    `${API_BASE_URL}/notifications/unread-count`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data.count;
};

/**
 * Mark a notification as read
 */
export const markNotificationAsRead = async (notificationId: string): Promise<void> => {
  const token = localStorage.getItem('token');
  await axios.patch(
    `${API_BASE_URL}/notifications/${notificationId}/read`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

/**
 * Mark all notifications as read
 */
export const markAllNotificationsAsRead = async (): Promise<void> => {
  const token = localStorage.getItem('token');
  await axios.post(
    `${API_BASE_URL}/notifications/mark-all-read`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
